import React, { useEffect, useRef, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { Card, Main, Skeleton } from '../../Components'
import ReactPaginate from 'react-paginate';

import axios from 'axios'
import moment from 'moment'

import './statuspages.css'
import { Link } from 'react-router-dom'
import { Table } from '../../Components/Table/Table'
import { PageHeader } from '../../Components/PageHeader/PageHeader'
import { componentStatus } from '../../Constants/Constants';
import { randomIntInterval } from '../../Helpers';
import { useSelector } from 'react-redux';

export function Statuspages() {


	const effectCalled = useRef(false)

	const navigate = useNavigate();
    const { user , org } = useSelector((state) => state.auth)

	const [isLoading, setIsLoading] = useState(false)
	const [statuspages, setStatuspages] = useState([])
	const [activePage, setActivePage] = useState(0);
	const [listPerPage, setListPerPage] = useState(10);
	const [totalRecords, setTotalRecords] = useState(0);


	useEffect( () => {
		if(effectCalled.current){ return ;}
		 
		async function fetchData() {
			const response = await getStatuspages({
				page : activePage / listPerPage,
				per_page : listPerPage
			})
		}
		fetchData();

		effectCalled.current = true ;
		
	}, [])



	const getStatuspages = async ({ page , per_page}) => {

		return new Promise(async(resolve, reject) => { 

			setIsLoading(true)
			// 
			// //

			
			
			if (user && user.token && org && org?.id ) {
				
				let params = {
					page : page ,
					per_page : per_page,
					 
				}

				const token = user?.token;


				await axios.get(`${process.env.REACT_APP_API_URL}/organizations/${org?.id}/statuspages` , {
					params :params,
					headers: {
						'Authorization': `Bearer ${token}`
					},
				})
				.then( res => res.data )
				.then( data => {

					// Total records 
					setTotalRecords(data.total);

					setStatuspages(data.data)

					setIsLoading(false)
		
					resolve(data.data) 
		
				})
				.catch(error => {
					if(error?.response?.data?.error ==='USER_NOT_LOGIN'){
						navigate('/logout')
					}
					setIsLoading(false)
					if (error.response) {
						if(typeof error.response.data.statusCode!=='undefined' && error.response.data.statusCode===404){
						
							setStatuspages([])
						}
						reject((typeof error.response.data.error.message !=='undefined') ? error.response.data.error.message : error.response.data.message);
					} else {
						// Something happened in setting up the request that triggered an Error
						if(typeof error.message==='undefined' || error.message ===null || error.message!=="API_HAS_BEEN_CANCELED"){
								reject(`Something went wrong. Thank you try later.`)
						}
					}
				})
			}else{
				setIsLoading(false)
			}

		})
	}
 
	
	const rows = statuspages.map((row , index) => {

		return (
			<div className="page-item mb-10"  key={index}>
				<div className="page-main_data">
					<div className='page-name'><Link to={`/pages/${row?.id}`} >{row.name}</Link></div>
					<div className="page-domain_info">
						
						<div className="page-sub_domain">
							<label htmlFor="">Sub domain : </label>
							<span>{
								row.hosted_subdomain 
								? <a 
									href={`https://${row.hosted_subdomain}${process.env.REACT_APP_STATUSPAGE_HOSTNAME}`} 
									target="_blank">{`${row.hosted_subdomain}${process.env.REACT_APP_STATUSPAGE_HOSTNAME}`}</a>
								: '-'
								}</span>
						</div>
						<div className="page_custom_domain">
							<label htmlFor="">Custom domain : </label>
							<span>{
								row.custom_domain 
								? <a 
									href={`https://${row.custom_domain}`} 
									target="_blank">{row.custom_domain}</a>
								: '-'
							}</span>
						</div>
					</div>
					<div className='page_created_at'>Created on {row.created_at ? moment(row.created_at).format('MMM D, YYYY [at] hh:mm A') : '-'}</div>	 
				</div>
				<div className="page-metrics_data">
					<div className="p-mtrx_item page_components">
						<div className="number">{row?.components?.total ?? 0}</div>
						<label htmlFor=""><Link to={`/pages/${row?.id}/components`}>Components</Link></label>
						{/* <div className="components-status">
							<ul>
							{
								componentStatus.map( (item , index) => {
									return (
										<li key={index}>
											<span className="icon">{item?.icon}</span>
											<label htmlFor="">{row?.components?.status[item?.value] ?? 0}</label>
										</li>
									)
								})
							}
							</ul>
						</div> */}
					</div>
					<div className="p-mtrx_item page_incidents">
						<div className="number">{row?.incidents?.total ?? 0}</div>
						<label htmlFor=""><Link to={`/pages/${row?.id}/incidents`}>Incidents</Link></label>
						{/* <div className="resolved-indice">
							{ row?.incidents?.status['RESOLVED']} / {row?.incidents?.total}    
							</div>   */}
					</div>
				</div>
			</div>
			);
		 
	});


	const SkeletonLoader_itemList = () => {
		return (
			[...Array(3)].map( ( row , row_index) => {
				return(

					<div className="page-item mb-10"  key={row_index}>
						<div className="page-main_data">
							<div className='page-name'><Skeleton  width={`${randomIntInterval(40 , 60)}%`} height={18} /></div>
							<div className="page-domain_info">
								
								<div className="page-sub_domain">
									<label htmlFor=""><Skeleton  width={60} height={14} radius="sm" /></label>
									<span><Skeleton  width={80} height={14} radius="sm" /></span>
								</div>
								<div className="page_custom_domain">
									<label htmlFor=""><Skeleton  width={60} height={14} radius="sm" /></label>
									<span><Skeleton  width={80} height={14} radius="sm" /></span>
								</div>
							</div>
							<div className='page_created_at'><Skeleton  width={60} height={14} radius="sm" /></div>		 
						</div>
						<div className="page-metrics_data">
							<div className="p-mtrx_item ">
								<div className="number"><Skeleton  width={40} height={40} radius="sm"/></div>
								<label htmlFor=""><Skeleton  width={100} height={14} radius="sm"  /></label>
								
							</div>
							<div className="p-mtrx_item ">
								<div className="number"><Skeleton  width={40} height={40} radius="sm"/></div>
								<label htmlFor=""><Skeleton className={'mt-10'} width={100} height={14} radius="sm" /></label>	
							</div>
						</div>
					</div>
				)
			})
		)
	}

	return (
		<>
		<Helmet>
			<title>{`Status pages - ${process.env.REACT_APP_APP_NAME}`}</title>
		</Helmet>
		<Main 
			breadcrumbsItems={[
				{ name: 'Home', link: '/' },
				{ name: 'Status Pages', link: '' },
			]}
			 >
				<PageHeader
					title="Status pages"
					// description="Give your account a recognisable name, so your team mates can easily switch between accounts."
                    actionBtns={[
						{
							name : 'Add Status page' , link : `/pages/new`, color : 'purple'
						}
					]}
					/>
					
				 
				{
					isLoading === true 
					? <SkeletonLoader_itemList />
					: rows
				}
				 
				{
					Math.ceil(totalRecords/ listPerPage) > 1 && 
					<ReactPaginate
						previousLabel={""}
						nextLabel={""}
						breakLabel={"..."}
						breakClassName={"break-me"}
						pageCount={Math.ceil(totalRecords/ listPerPage)} 
						marginPagesDisplayed={2}
						pageRangeDisplayed={5}
						onPageChange={ async (e) => {

							const number = e.selected;
							//console.log('number : ' , number );

							setActivePage(number)
							await getStatuspages({
								page : Math.ceil(number/ listPerPage),
								per_page : listPerPage
							})
						}}
						containerClassName={"pagination"}
						subContainerClassName={"pages pagination"}
						activeClassName={"active"}/>
				}
				 
			
		</Main>
		</>
	)
}
